import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
let SoftwareApiService = class SoftwareApiService {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
        this._endpointUrl = '/software';
    }
    getSoftware() {
        return this._httpClient.get(`${this._endpointUrl}`);
    }
};
SoftwareApiService.ctorParameters = () => [
    { type: HttpClient }
];
SoftwareApiService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [HttpClient])
], SoftwareApiService);
export { SoftwareApiService };
